import _ from 'lodash';

import { getUrl } from './url';

export function getLocationUrl(location) {
  let converter = getConverter(location);

  let queryParams = _.isFunction(converter.getQueryParams) ? converter.getQueryParams(location) : {};
  return getUrl(converter.getPath(location), queryParams);
}

function getConverter(location) {
  let converter = location && urlConverters.get(location.constructor);
  if (!converter) {
    throw new Error(`[${_.get(location, 'constructor.name')}] does not have a URL converter`);
  }

  return converter;
}

let urlConverters = new Map();

export function registerUrlConverter(Model, converter) {
  urlConverters.set(Model, converter);
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/location_url.js